/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraDataCenterAvatarUrl {
    getFixupPrototypeFunction() { return JiraDataCenterAvatarUrl.fixupPrototype; }

    static newInstance(model: Partial<JiraDataCenterAvatarUrl>): JiraDataCenterAvatarUrl {
        let obj = Object.assign(new JiraDataCenterAvatarUrl(), model);
        JiraDataCenterAvatarUrl.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraDataCenterAvatarUrl>): JiraDataCenterAvatarUrl {
        if (!model) return null;
        return JiraDataCenterAvatarUrl.newInstance(<JiraDataCenterAvatarUrl> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraDataCenterAvatarUrl) {
        if (!obj) return;

        models.JiraDataCenterAvatarUrl.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraDataCenterAvatarUrl): boolean {
        Object.setPrototypeOf(obj, JiraDataCenterAvatarUrl.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Avatar URL of type 16x16
     */
    url_16x16: string;

    /**
     * Avatar URL of type 24x24
     */
    url_24x24: string;

    /**
     * Avatar URL of type 32x32
     */
    url_32x32: string;

    /**
     * Avatar URL of type 48x48
     */
    url_48x48: string;

}
